import { auth, db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

//const BASE_URL = 'https://cookfromvideo-server.onrender.com/api';
//const BASE_URL = 'http://localhost:3000';          // לוקלי - ללא /api
const BASE_URL = 'https://us-central1-cookwithai-b1a9e.cloudfunctions.net/api';  // פרודקשן

// ── headers שקטים עם זהות המשתמש ──
const getUserHeaders = () => {
  const user = auth.currentUser;
  return {
    'Content-Type':  'application/json',
    'X-User-Id':     user?.uid   || 'anonymous',
    'X-User-Email':  user?.email || 'unknown',
  };
};

// ── כתיבת לוג ישירות ל-Firestore מה-Frontend ──
// בפרודקשן: השרת כותב בעצמו → כאן רושמים רק לוקלית (למניעת כפילות)
const IS_LOCAL = window.location.hostname === 'localhost';

const clientLog = async (data) => {
  if (!IS_LOCAL) return; // בפרודקשן — השרת מטפל בזה
  try {
    await addDoc(collection(db, 'logs'), {
      ...data,
      source:    'client',
      timestamp: serverTimestamp(),
    });
  } catch (e) {
    console.warn('clientLog failed:', e.message);
  }
};

// ── זיהוי 429 ──
const handle429 = async (endpoint, payload) => {
  const user = auth.currentUser;
  await clientLog({
    level:     'warning',
    event:     'rate_limit_hit',
    message:   `מכסת API הוגעה (429) — Gemini`,
    endpoint,
    payload:   String(payload).substring(0, 200),
    userId:    user?.uid   || 'anonymous',
    userEmail: user?.email || 'unknown',
  });
  throw new Error('הגענו למכסת השימוש היומית ב-AI. נסה שוב בעוד כמה דקות.');
};

/**
 * חילוץ מתכון מלינק
 */
export const extractRecipe = async (url) => {
  try {
    const response = await fetch(`${BASE_URL}/extract`, {
      method: 'POST',
      headers: getUserHeaders(),
      body: JSON.stringify({ url: url.trim() }),
    });

    if (response.status === 429) return await handle429('/extract', url);

    const data = await response.json();
    if (!response.ok || !data.success) {
      throw new Error(data.error || 'לא הצלחנו לחלץ את המתכון');
    }
    return data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

/**
 * חילוץ מתכון מטקסט
 */
export const extractFromText = async (text) => {
  try {
    const response = await fetch(`${BASE_URL}/extract-text`, {
      method: 'POST',
      headers: getUserHeaders(),
      body: JSON.stringify({ text }),
    });

    if (response.status === 429) return await handle429('/extract-text', text);

    const data = await response.json();
    if (!response.ok || !data.success) {
      throw new Error(data.error || 'לא הצלחנו לחלץ את המתכון');
    }
    return data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

/**
 * חילוץ מתכון מתמונות
 */
export const extractFromImages = async (images) => {
  try {
    const response = await fetch(`${BASE_URL}/extract-images`, {
      method: 'POST',
      headers: getUserHeaders(),
      body: JSON.stringify({ images }),
    });

    if (response.status === 429) return await handle429('/extract-images', `${images?.length} images`);

    const data = await response.json();
    if (!response.ok || !data.success) {
      throw new Error(data.error || 'לא הצלחנו לחלץ את המתכון');
    }
    return data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};